import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IHeroBlockProps } from "./HeroBlock.props";
export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  return (
    <WohaSection
      className={props.parentClass}
      containerWidth={props.variant === "background-image" ? "wide" : "default"}
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </WohaSection>
  );
};
HeroBlock.displayName = "Block::HeroBlock";
